import { render, staticRenderFns } from "./IFrameModal.vue?vue&type=template&id=19abd8e8&"
import script from "./IFrameModal.vue?vue&type=script&lang=js&"
export * from "./IFrameModal.vue?vue&type=script&lang=js&"
import style0 from "./IFrameModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports